import { useEffect, useState } from 'react';
import { useMember } from '../context/MemberContext';
import { useAppInfo } from '../context/AppContext';
import { config } from '../config';
import apiClient from '../api/client';
import './EnrollPage.css';

export default function EnrollPage() {
  const { member } = useMember();
  const { onlineName } = useAppInfo();
  const [activeSignupUrl, setActiveSignupUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!member?.personId) return;
    apiClient.get(`/PwaDashboard/signupurl/${member.personId}`)
      .then(res => setActiveSignupUrl(res.data?.data?.signupUrl ?? null))
      .catch(() => setActiveSignupUrl(null));
  }, [member?.personId]);

  if (!member?.siteId) {
    return (
      <div className="enroll-page">
        <p className="enroll-empty">No site information available.</p>
      </div>
    );
  }

  const tenant = onlineName || config.onlineName;
  const defaultSrc = `${config.onlineBaseUrl}/${tenant}/${member.siteId}/packagesboxes`;
  const src = activeSignupUrl || defaultSrc;

  return (
    <div className="enroll-page">
      <iframe
        className="enroll-iframe"
        src={src}
        title="Membership Signup"
        allow="payment"
      />
    </div>
  );
}
